import {Colors} from '../Color';

const BORDER_RADIUS = 8;
const DEFAULT_CELL_PADDING = 15;
const CELL_LINE_HEIGHT = 20;
const BORDER_SETTING = `1px solid ${Colors.Tan30}`;

export {BORDER_RADIUS, DEFAULT_CELL_PADDING, CELL_LINE_HEIGHT, BORDER_SETTING};
